
import { useTranslation } from 'react-i18next';

export default function Amenities() {
  const { t } = useTranslation();

  const amenities = [
    {
      icon: 'fa-solid fa-house-signal',
      title: t('amenities_smart_home'),
      description: t('amenities_smart_home_desc')
    },
    {
      icon: 'fa-solid fa-temperature-arrow-up',
      title: t('amenities_heating'),
      description: t('amenities_heating_desc')
    },
    {
      icon: 'fa-solid fa-wind',
      title: t('amenities_climate'),
      description: t('amenities_climate_desc')
    },
    {
      icon: 'fa-solid fa-water-ladder',
      title: t('amenities_pool'),
      description: t('amenities_pool_desc')
    },
    {
      icon: 'fa-solid fa-music',
      title: t('amenities_audio'),
      description: t('amenities_audio_desc')
    },
    {
      icon: 'fa-solid fa-shield-halved',
      title: t('amenities_security'),
      description: t('amenities_security_desc')
    },
    {
      icon: 'fa-solid fa-spa',
      title: t('amenities_wellness'),
      description: t('amenities_wellness_desc')
    },
    {
      icon: 'fa-solid fa-dumbbell',
      title: t('amenities_fitness'),
      description: t('amenities_fitness_desc')
    },
    {
      icon: 'fa-solid fa-wine-bottle',
      title: t('amenities_wine'),
      description: t('amenities_wine_desc')
    },
    {
      icon: 'fa-solid fa-seedling',
      title: t('amenities_irrigation'),
      description: t('amenities_irrigation_desc')
    },
    {
      icon: 'fa-solid fa-charging-station',
      title: t('amenities_ev'),
      description: t('amenities_ev_desc')
    },
    {
      icon: 'fa-solid fa-solar-panel',
      title: t('amenities_solar'),
      description: t('amenities_solar_desc')
    }
  ];

  return (
    <section className="py-24 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-4 text-gray-900">
          {t('amenities_title')}
        </h2>
        <p className="text-center text-gray-600 mb-16 text-lg">
          {t('amenities_subtitle')}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {amenities.map((amenity, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl mb-6">
                <i className={`${amenity.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900">{amenity.title}</h3>
              <p className="text-gray-600 leading-relaxed">{amenity.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
